package com.kaihuoy.home.screens

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.kaihuoy.shared.data.User
import com.kaihuoy.components.common.*
import com.kaihuoy.web.router.AppRouterState

@Composable
fun PainekoeScreen(user: User?, isAdmin: Boolean, onLogout: () -> Unit) {
    var showForm by remember { mutableStateOf(false) }

    if (showForm) {
        NewPainekoeScreen(user, onBack = { showForm = false })
        return
    }

    PageLayout(greeting = getGreeting(user?.displayName), onLogout = onLogout) {
        Div(attrs = { style { padding(20.px, 0.px); width(100.percent); boxSizing("border-box") } }) {

            H1(attrs = { style { marginBottom(8.px) } }) {
                Text("Putkityö")
            }

            P(attrs = {
                style {
                    marginBottom(32.px)
                    color(KaihuTheme.TextSecondary)
                    fontSize(1.05.em)
                }
            }) {
                Text("Koeponnistuspöytäkirjat")
            }

            Div(attrs = {
                style {
                    display(DisplayStyle.Grid)
                    gridTemplateColumns("repeat(auto-fill, minmax(min(280px, 100%), 1fr))")
                    gap(24.px)
                }
            }) {
                DashboardCard(
                    title = "Uusi koeponnistus",
                    subtitle = "Täytä koeponnistuspöytäkirja",
                    icon = "droplet",
                    containerColor = Color("#0E4C6E"),
                    onClick = { showForm = true }
                )

                if (isAdmin) {
                    DashboardCard(
                        title = "Kaikki pöytäkirjat",
                        subtitle = "Selaa ja lataa tallennetut pöytäkirjat",
                        icon = "clipboard-list",
                        containerColor = KaihuTheme.CardBackground,
                        onClick = { AppRouterState.navigate("hallinta") }
                    )
                }
            }
        }
    }
}
